export enum ThemeE {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}
